import "./App.css";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import Header from "./Components/Header/Header";
import Footer from "./Components/Footer/Footer";
import Home from "./Components/Home/Home";
import ProductDescription from "./Components/ProductDescription/ProductDescription";
import Form from "./Components/Form/Form";
import Places from "./Components/Places/Places";
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div>
      <Router>
        <Header />
        <div className="in_between_line" />
        <Routes>
          <Route path="/" element={<Home title="Home" />} />
          <Route path="/places" element={<Places title="Places" />} />
        </Routes>
        <ProductDescription />
        <Form />
        <Footer />
      </Router>
    </div>
  );
}

export default App;
